"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartesianPlotConstructionOptions = void 0;
const rc_js_util_1 = require("rc-js-util");
const core_1 = require("@visualization-tools/core");
const e_screen_unit_1 = require("./e-screen-unit");
/**
 * @public
 * {@inheritDoc ICartesian2dPlotConstructionOptions}
 */
class CartesianPlotConstructionOptions {
    constructor(options) {
        this.useDefaultAxis = true;
        Object.assign(this, options);
    }
    getPlotArea(attachPoint) {
        const dims = attachPoint.canvasDims;
        const margins = this.gutterOptions.margins.slice();
        switch (this.gutterOptions.unit) {
            case e_screen_unit_1.EScreenUnit.ActualPixel:
                this.gutterOptions.margins.mat3TransformLength(dims.transforms.pixelToClip, margins);
                break;
            case e_screen_unit_1.EScreenUnit.Clip:
                // clip is the required unit, no action needed
                break;
            case e_screen_unit_1.EScreenUnit.CssPixel:
                this.gutterOptions.margins.mat3TransformLength(dims.transforms.cssToClip, margins);
                break;
            default:
                rc_js_util_1._Production.assertValueIsNever(this.gutterOptions.unit);
        }
        return core_1.PlotArea.createOneWithMargins(this.plotPosition, margins);
    }
}
exports.CartesianPlotConstructionOptions = CartesianPlotConstructionOptions;
//# sourceMappingURL=cartesian2d-plot-construction-options.js.map